import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { TranslateService } from "@ngx-translate/core";
import { CapturedField, DynamicField, FormDataDto } from "src/app/services/dtos";
import { UtilService } from "src/app/services/util.service";
import { WizardComponent } from "../wizard.component";

@Component({
	selector: 'app-confirmation',
	templateUrl: './confirmation.component.html',
	styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent implements OnInit{

	@Input() texts: CapturedField[];
	@Input() images: CapturedField[];

	@Output() onNext = new EventEmitter();
	@Output() onBack = new EventEmitter();

	chunkedFields: CapturedField[][] = [];

	constructor(translate: TranslateService, public util: UtilService, private sanitizer: DomSanitizer) {

	}

	ngOnInit() {
  		this.chunkedFields = this.chunkFields(this.texts);
	}

	chunkFields(list: CapturedField[]): CapturedField[][] {
		const chunkSize = 2; // 2 items per row
		const result: CapturedField[][] = [];

		for (let i = 0; i < list.length; i += chunkSize) {
			result.push(list.slice(i, i + chunkSize));
		}

		return result;
	}

	getImageUrl(file: File): SafeUrl  {
		return this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(file));
	}

	previousStep() {
		this.onBack.emit();
	}

	nextStep() {
		this.onNext.emit();
	}

	

}